export default function TheLandWeTend() {
  return <section data-section-id="230477" id="your-dedicated-it-department" className="bg-background text-foreground relative min-h-[100svh] flex flex-col items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: "url('https://rapidtechworks.com/wp-content/uploads/2026/04/DSC5684-scaled.jpg')"
      }} />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/10 via-background/80 to-background backdrop-blur-[1px]" />
      </div>

      {}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto flex flex-col items-center w-full">
        <h1 className="font-default font-bold text-5xl sm:text-6xl md:text-8xl lg:text-9xl tracking-tighter text-secondary leading-[1.1]">
          <span className="block mb-2 md:mb-4 text-foreground">Your Team,</span>
          <span className="block mb-2 md:mb-4 text-primary">Your Tech,</span>
          <span className="block">Your Partner</span>
        </h1>
        <p className="mt-8 text-lg md:text-xl text-foreground/80 max-w-2xl font-default leading-relaxed">
          We’re not just your IT guys. We’re your dedicated partners, coming alongside your business to fuel growth through reliable technology.
        </p>
      </div>

      {}
      <div className="absolute bottom-16 left-1/2 -translate-x-1/2 flex flex-col items-center gap-6 z-10">
        <span className="text-[10px] tracking-[0.4em] uppercase text-secondary/60 font-mono font-medium">
          Scroll to Explore
        </span>
        <div className="w-[1px] h-24 bg-secondary/20 relative overflow-hidden rounded-full">
          <div className="w-1.5 h-3 bg-primary rounded-[100%_100%_50%_50%] absolute left-1/2 -translate-x-1/2 top-0 animate-[seed-fall_2.5s_cubic-bezier(0.4,0,0.2,1)_infinite]" />
        </div>
      </div>

      {}
      <style>{`
        @keyframes seed-fall {
          0% { 
            transform: translate(-50%, -20px) scale(0.8); 
            opacity: 0; 
          }
          20% { 
            transform: translate(-50%, 10px) scale(1); 
            opacity: 1; 
          }
          80% { 
            transform: translate(-50%, 70px) scale(1); 
            opacity: 1; 
          }
          100% { 
            transform: translate(-50%, 100px) scale(0.5); 
            opacity: 0; 
          }
        }
      `}</style>
    </section>;
}